import { c as _c } from "react/compiler-runtime";
import { Transition } from '@headlessui/react';
import { Hint } from '@systemeio/ui';
import AffiliateDashboardPromotionLink from 'modules/affiliate-dashboard/components/affiliate-dashboard-promotion-link';
import { useAffiliateDashboardPromotion } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-promotion';
import { AffiliateDashboardPromotionInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-promotion-interface';
import React, { useState, type JSX } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { ArrowDownIcon } from '@systemeio/ui/icons';
interface AffiliatePromotionProps {
  affiliateId?: string;
}
const AffiliateDashboardPromotion = t0 => {
  const $ = _c(57);
  const {
    affiliateId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const {
    data: affiliatePromotion
  } = useAffiliateDashboardPromotion(opened);
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.affiliate_dashboard.promote_first");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-text-primary text-[17px] font-bold">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpened(_temp);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== opened || $[6] !== t) {
    t4 = opened ? t("dashboard.affiliate_dashboard.hide_stats") : t("dashboard.affiliate_dashboard.show_stats");
    $[5] = opened;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="text-brand-primary hidden lg:inline">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = `transition-transform ${opened && "rotate-180"} stroke-brand-primary`;
  let t7;
  if ($[10] !== t6) {
    t7 = <ArrowDownIcon className={t6} />;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <button className="ring-brand-primary flex items-center gap-1.5 rounded-md outline-hidden ring-offset-1 focus-visible:ring-2" onClick={t3}>{t5}{t7}</button>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t2 || $[16] !== t8) {
    t9 = <div className="flex justify-between gap-3">{t2}{t8}</div>;
    $[15] = t2;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t("dashboard.affiliate_dashboard.promote_second");
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10) {
    t11 = <span className="text-text-primary">{t10}</span>;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t9) {
    t12 = <div className="flex flex-col gap-1">{t9}{t11}</div>;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== affiliateId) {
    t13 = <AffiliateDashboardPromotionLink affiliateId={affiliateId} />;
    $[25] = affiliateId;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("dashboard.affiliate.last_30_days");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("dashboard.affiliate_dashboard.freemium_registrations");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14 || $[32] !== t15) {
    t16 = <Hint label={t14}>{t15}</Hint>;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== affiliatePromotion || $[35] !== t16) {
    t17 = <AffiliatePromotionContent affiliatePromotion={affiliatePromotion} title={t16}>{_temp2}</AffiliatePromotionContent>;
    $[34] = affiliatePromotion;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t) {
    t18 = t("dashboard.affiliate.current_active");
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t) {
    t19 = t("dashboard.affiliate_dashboard.active_customers");
    $[39] = t;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t18 || $[42] !== t19) {
    t20 = <Hint label={t18}>{t19}</Hint>;
    $[41] = t18;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== affiliatePromotion || $[45] !== t20) {
    t21 = <AffiliatePromotionContent affiliatePromotion={affiliatePromotion} title={t20}>{_temp3}</AffiliatePromotionContent>;
    $[44] = affiliatePromotion;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t17 || $[48] !== t21) {
    t22 = <div className="flex justify-between gap-3">{t17}{t21}</div>;
    $[47] = t17;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== opened || $[51] !== t22) {
    t23 = <Transition show={opened} enter="ease-linear duration-200" enterFrom="-translate-y-1 opacity-0" enterTo="translate-y-0 opacity-100" leave="ease-linear duration-200" leaveFrom="translate-y-0 opacity-100" leaveTo="-translate-y-1 opacity-0">{t22}</Transition>;
    $[50] = opened;
    $[51] = t22;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  let t24;
  if ($[53] !== t12 || $[54] !== t13 || $[55] !== t23) {
    t24 = <div className="bg-background-secondary flex w-full flex-col gap-3 overflow-x-hidden rounded-lg px-6 py-4">{t12}{t13}{t23}</div>;
    $[53] = t12;
    $[54] = t13;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  return t24;
};
const AffiliatePromotionContent = t0 => {
  const $ = _c(8);
  const {
    affiliatePromotion,
    children,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <span className="text-text-primary">{title}</span>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== affiliatePromotion || $[3] !== children) {
    t2 = affiliatePromotion ? <span className="text-text-primary text-[17px] font-bold">{children(affiliatePromotion)}</span> : <span className="bg-skeleton-primary w-fit animate-pulse rounded-lg px-5 text-transparent">.</span>;
    $[2] = affiliatePromotion;
    $[3] = children;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex w-1/2 flex-col justify-between gap-3">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default AffiliateDashboardPromotion;
function _temp(prev) {
  return !prev;
}
function _temp2(affiliatePromotion_0) {
  return affiliatePromotion_0.freeRegistrationsCount;
}
function _temp3(affiliatePromotion_1) {
  return affiliatePromotion_1.paidCount;
}